import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GridColDef } from "@mui/x-data-grid";

import { DataLoader, QuickModule } from "@uderly/react-uderly-ui";
import IqSpaceApi from '../../api/IqSpace';
import Separator from '../components/Separator';
import { format } from "date-fns";
import { Link } from "react-router-dom";
import CellMediaThumb from "../components/Module/CellMediaThumb";

const Tickets = () => {

	const { t } = useTranslation();

	const [tickets, setTickets] = useState<[]>();

	const columns: GridColDef[] = [
		{
			field: 'id',
			headerName: t('id') as string,
			minWidth: 40
		},
		{
			field: 'event',
			headerName: t('event') as string,
			minWidth: 250,
			flex: 1,
			renderCell: params => {
				const { row } = params;

				return (
					<div className="td-v-center">
						<CellMediaThumb o={params.row.event} path={"/events"} />

						{row.event.title} ({format(new Date(params.row.event.date_time.substring(0, 19)), "E d/MM/yyyy H:mm")})
					</div>
				);
			}
		},
		{
			field: 'purchased_at',
			headerName: t('purchased-at'),
			minWidth: 180,
			renderCell: params => {
				const { row } = params;

				return !row.purchased_at ? "" : format(new Date(row.purchased_at), "E d/MM/yyyy H:mm");
			}
		},
		{
			field: 'status',
			headerName: t('status'),
			minWidth: 180,
			renderCell: params => {
				const { row } = params;

				if (row.voucher_code)
					return t("voucher-code") + " " + row.voucher_code;

				if (row.status_id === 4)
					return t("refunded");

				return t("paid");
			}
		},
		{
			field: 'eventLink',
			headerName: '',
			minWidth: 180,
			renderCell: params =>
				<Link to={`/event/${params.row.event.id}`}>{t("go-to-event")}</Link>
		}
	];

	useEffect(() => {
		const fetchTickets = async () => {
			const response = await await IqSpaceApi.MyTickets();
console.log(response)
			if (response && response.status === 200) {
				setTickets(response.data.data);
			}
		}

		fetchTickets();
	}, []);

	return (<div className="tickets page">
		<h1>{t("your-tickets")}</h1>

		<Separator />

		{!tickets && <DataLoader />}

		{tickets && <QuickModule
			columns={columns}
			records={tickets}
			disableView />}
	</div>);
}

export default Tickets;